<template>
  <div>
    <div class="gl_title_bar marginBottom10">
      <div class="gl_tb_left">
        <span class="normaltitle">{{storeName}}培训管理平台</span>
      </div>
    </div>
    <div class="toptitle">
      <div class="tt1">学分管理与查询</div>
      <div class="tt2 el-icon-d-arrow-right">返回上一级</div>
    </div>
    <div class="top">
      <div>
        <span>项目名称：</span>
        <el-select v-model="value"
                   size="small"
                   placeholder="学分匹配状态">
          <el-option v-for="item in options"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value">
          </el-option>
        </el-select>
      </div>
      <el-input placeholder="请输入内容"
                v-model="input3"
                size="small"
                style="width:480px">
        <el-button slot="append"
                   icon="el-icon-search"></el-button>
      </el-input>
      <el-button type="success"
                 class="topBtn"
                 size="small">导出</el-button>
    </div>
    <div class="mid">
      <el-table ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                class="mtable"
                border
                @selection-change="handleSelectionChange">
        <el-table-column type="selection"
                         width="39"
                         style="text-align: center;">
        </el-table-column>
        <el-table-column label="日期"
                         width="120">
          <template slot-scope="scope">{{ scope.row.date }}</template>
        </el-table-column>
        <el-table-column prop="name"
                         label="姓名"
                         width="120">
        </el-table-column>
        <el-table-column prop="address"
                         label="地址"
                         show-overflow-tooltip>
        </el-table-column>
      </el-table>
      <!-- <div class="pagination_Wrap"> -->
      <pagination v-if="page.total>0"
                  :total="page.total"
                  :limit="page.pageSize"
                  :page="page.currentPage"
                  @page-change="pageChange"></pagination>
      <!-- </div> -->
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      storeName: '',
      page: {
        total: 3,
        pageSize: 6,
        currentPage: 1
      },
      tableData: [{
        date: '2016-05-03',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1518 弄'
      }, {
        date: '2016-05-02',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1518 弄'
      }, {
        date: '2016-05-04',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1518 弄'
      }, {
        date: '2016-05-01',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1518 弄'
      }, {
        date: '2016-05-08',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1518 弄'
      }, {
        date: '2016-05-06',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1518 弄'
      }, {
        date: '2016-05-07',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1518 弄'
      }],
    }
  },
  created () {
    this.storeName = localStorage.getItem('storeName')
  },
  methods: {
    pageChange (val) {
      if (this.page.currentPage == val) return
      this.page.currentPage = val;
    },
  }
};
</script>

<style lang="scss" scoped>
.toptitle {
    width: 100%;
    box-sizing: border-box;
    height: 57px;
    background: #f6f7fb;
    padding-left: 17px;
    margin: 30px 0 30px 0;
    display: flex;
    align-items: center;
    line-height: 56px;
    .tt1 {
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #0b8586;
    }
    .tt2 {
        font-size: 14px;
        font-family: Microsoft YaHei;
        margin-left: 36px;
        cursor: pointer;
    }
}
.top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 25px;
    .topBtn {
        width: 100px;
        background-color: #0b8586;
    }
}
.mid {
    .mtable {
        width: 100%;
        ::v-deep thead {
            th {
                background-color: #0b8586 !important;
                color: #fff;
            }
        }
    }
}
</style>
